import { platformRoles, accessModes } from './platformRoles';

/**
 * ROAR-4970 (ROAR-4802 / P1.11, PR3) — AC1's tier-constrained invite GRANT matrix, hardcoded
 * client-side (developer-confirmed during /plan) mirroring api-backend-provapt's own
 * src/utils/rbac/inviteGrantMatrix.js verbatim — confirmed against that shipped module during
 * /build, not just the design doc. No endpoint exposes this dynamically; if the backend matrix
 * ever changes, this must be updated in lockstep.
 *
 * `customer_admin` may grant the full customer-tier family within their own company;
 * `mssp_admin` may grant the SAME customer-tier family into a company they manage (AC15) — an
 * MSSP-tier invite is a fundamentally different operation this matrix does not cover.
 * `customer_user`/`mssp_user` have no invite rights at all (no entry below).
 */
const CUSTOMER_TIER_GRANTS = [
  { platform_role: platformRoles.CUSTOMER_ADMIN, access_mode: accessModes.WRITE },
  { platform_role: platformRoles.CUSTOMER_ADMIN, access_mode: accessModes.READ },
  { platform_role: platformRoles.CUSTOMER_USER, access_mode: accessModes.WRITE },
  { platform_role: platformRoles.CUSTOMER_USER, access_mode: accessModes.READ },
];

const GRANTABLE_BY_INVITER = {
  [platformRoles.CUSTOMER_ADMIN]: CUSTOMER_TIER_GRANTS,
  [platformRoles.MSSP_ADMIN]: CUSTOMER_TIER_GRANTS,
};

/**
 * @param {string|null|undefined} inviterPlatformRole
 * @returns {Array<{platform_role: string, access_mode: string}>} a fresh array — never the
 *   shared SSOT reference, so a caller mutating the result can't corrupt the matrix.
 */
export const getGrantableRoles = (inviterPlatformRole) => [
  ...(GRANTABLE_BY_INVITER[inviterPlatformRole] || []),
];
